<template>

  <v-card>
    <v-card-title>Formulier aanmaken</v-card-title>
    <v-card-text>

      <FormulateForm @submit="submitForm" name="createForm">

        <template v-if="!createBlankForm">
          <p>
            <strong>Template naam:</strong><br>
            {{ duplicate_form.form_name }}
          </p>
          <p v-if="duplicate_form.form_description">
            <strong>Template beschrijving:</strong><br>
            <span style="white-space: pre-wrap;">{{ duplicate_form.form_description }}</span>
          </p>
        </template>

        <FormulateInput
            label="Formulier naam"
            name="form_name"
            v-model="form_name"
            validation="required"
            :validation-messages="{
              required: 'Formulier naam is verplicht.'
            }"
        />

        <template v-if="createBlankForm">
          <FormulateInput
              label="Formuliertype"
              type="select"
              required
              :options="{'default': 'Standaard', 'workflow': 'Workflow met fases'}"
              v-model="form_type"
              class="mb-0"
          />
          <ul class="text-caption text--secondary mb-5">
            <li>Standaard: Het formulier door één gebruiker ingevuld.</li>
            <li>Workflow met fases: Het formulier kan deels ingevuld worden, om vervolgens doorgestuurd te worden naar een andere gebruiker om hem verder in te vullen.</li>
          </ul>
        </template>

        <FormulateInput
            label="Map"
            type="select"
            :options="folder_options"
            name="form_folder"
            v-model="form_folder"
            validation="required"
            error-behavior="live"
            :disabled="isLoading"
        />
      </FormulateForm>

    </v-card-text>
    <v-card-actions class="background-color">

      <v-btn
          depressed
          color="primary"
          @click="triggerSubmitForm"
          :disabled="isSaving"
      >
        Formulier aanmaken
      </v-btn>

      <v-btn
          outlined
          color="secondary"
          @click="closeFormCreateDialog"
      >
        Annuleren
      </v-btn>
    </v-card-actions>
  </v-card>

</template>

<script>
import {mapGetters} from "vuex";
import folderHelpers from "@/mixins/folderHelpers";
import router from "@/plugins/routes";

export default {
  name: "CreateForm",
  mixins: [
      folderHelpers,
  ],
  props: {
    folder_id: {
      type: String,
      default: null
    },
    // Can be a form object or null to create a blank form.
    duplicate_form: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      template: '',
      form_name: '',
      form_folder: '',
      form_type: 'default',
      folder_options: {},
      isLoading: false,
      isSaving: false,
    }
  },
  async mounted () {
    this.isLoading = true;
    this.folder_options = await this.getFolderOptions(this.CurrentClient);
    this.isLoading = false;
    // Set default folder if folder_id is passed
    if (this.folder_id) {
      this.form_folder = this.folder_id;
    }
  },
  computed: {
    ...mapGetters({CurrentClient: "CurrentClient"}),

    createBlankForm() {
      return this.duplicate_form === null;
    }
  },
  methods: {
    triggerSubmitForm() {
      // Trigger submit of named Vue Formulate form
      this.$formulate.submit('createForm')
    },
    // Send the form to the API endpoint
    async submitForm() {
      this.isSaving = true;
      try {

        // If duplicating an existing form, add the form_id to the payload
        if (this.duplicate_form) {
          const new_form_id = await this.$store.dispatch('createDuplicateFromForm', {
            form_id: this.duplicate_form.form_id,
            new_client_id: this.CurrentClient,
            new_folder_id: this.form_folder,
            new_form_name: this.form_name,
            published: true,
          });

          // Redirect to form edit page
          await router.push({name: 'form_edit', params: {form_id: new_form_id}})
        }
        else {
          await this.$store.dispatch('createForm', {
            form_name: this.form_name,
            folder_id: this.form_folder,
            form_type: this.form_type,
            schema: [],
          });
        }

        this.$toast.success("Formulier " + this.form_name + " is aangemaakt.");
      } catch (error) {
        this.$toast.error("Het formulier kon niet worden aangemaakt");
        console.log(error);
      }
      this.isSaving = false;
      this.$emit('formCreated');
    },
    closeFormCreateDialog() {
      this.$emit('formCreateCancelled');
      this.resetFormValues();
    },
    resetFormValues() {
      this.form_name = '';
      this.form_folder = '';
      this.form_type = 'default';
    },
  }
}
</script>

<style scoped>

</style>